import ModalHeading from 'components/atoms/students/ModalHeading';
import ModalText from 'components/atoms/students/ModalText';
import React from 'react';
import styled from '@emotion/styled';
export default (props) => {
    const { heading, isError, text } = props;
    return (React.createElement(TextContainer, null,
        React.createElement(ModalHeading, { isError: isError, text: heading }),
        text ? React.createElement(ModalText, { text: text }) : null));
};
const TextContainer = styled.div `
  margin-bottom: 60px;
  white-space: pre-wrap;
`;
